import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor';
import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo';
import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor;
  basicInfo?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo;
  engagement?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement;
};
